<template>
    <div class="blurCapFeed">
        <BlurCapImageSkeleton class="blurCapItem"
            orientation="portrait"
            v-for="index in 2"
            :key="index"/>
    </div>
</template>

<script>
    import BlurCapImageSkeleton from '@/components/templates/blurCapImage/BlurCapImageSkeleton'

    export default {
        name: 'FeedSkeleton',
        components: {
            BlurCapImageSkeleton
        }
    }
</script>